import api from '../utilities/api';

const postComment = (service = 'bo', data) => {
  return api.post(`/${service}/opinions/external-comment/`, {
    ...data,
  });
};

export { postComment };
